export const config = {
  services: {
    api: 'https://api.backstage.taste.dev.xela.co',
    apiContent: 'https://api.testing.xela.co/v1'
  },
};

export default config;
